import { z } from 'zod';

export const BusinessOrganisationLevelsFeSchema = z.enum([
  'root',
  'group',
  'division',
  'region',
  'subRegion',
]);

interface BusinessOrganisation {
  id: string;
  name: string;
  units?: BusinessOrganisation[];
}

export const BusinessOrganisationSchema = z.object({
  id: z.string(),
  name: z.string(),
  units: z.any().optional(),
});

export const BusinessOrganisationFeSchema = z.array(
  z.object({
    name: z.string(),
    level: BusinessOrganisationLevelsFeSchema,
  })
);

// organisation tree (for user > business organisation > edit)
export type OrganisationTreeMap = {
  value: string;
  title: string;
  children: OrganisationTreeMap[];
};

export const OrganisationTreeMapFeSchema: z.ZodSchema<OrganisationTreeMap> =
  z.lazy(() =>
    z.object({
      value: z.string(),
      title: z.string(),
      children: z.array(OrganisationTreeMapFeSchema),
    })
  );

export type BusinessOrganisationFeModel = z.infer<
  typeof BusinessOrganisationFeSchema
>;
export type OrganisationTreeMapFeModel = z.infer<
  typeof OrganisationTreeMapFeSchema
>;
export type BusinessOrganisationLevelsFeModel = z.infer<
  typeof BusinessOrganisationLevelsFeSchema
>;
export type BusinessOrganisationModel = BusinessOrganisation;
